<script lang="ts">
  export let size: number | void = null;
  export let color: string = 'white';

  $: sizeStyle = (size && `width: ${size}px; height: ${size}px;`) || '';
  $: cssVariables = `--border-color:${color};`;
  $: style = cssVariables + sizeStyle;
</script>

<div class="lds-ring {$$restProps.class || ''}" {style}>
  <div />
  <div />
  <div />
  <div />
</div>

<style lang="scss">
  .lds-ring {
    display: inline-block;
    position: relative;
  }

  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    border: 4px solid var(--border-color);
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: var(--border-color) transparent transparent transparent;
  }

  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }

  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }

  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }

  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
